import React from 'react';

import { PageHeader } from '@components/PageHeader';
import { CardContainer } from '@components/CardContainer';

import { useThemeGetter } from '@hooks';

import { mainInfo } from '@consts';
import { ProfileInfoBox } from './ProfileInfoBox';

import { CardsContainer, ProfileContainer } from './ProfileCard.styled';

export const ProfileCard = () => {
  const {
    theme: { TitleReverse },
  } = useThemeGetter();

  return (
    <CardContainer>
      <PageHeader text="Profile" headerColor={TitleReverse} />
      <ProfileContainer>
        <CardsContainer>
          <ProfileInfoBox infoList={mainInfo.ABOUT_INFO} />
          <ProfileInfoBox title="My Skills" infoList={mainInfo.SKILL_INFO} />
        </CardsContainer>
      </ProfileContainer>
    </CardContainer>
  );
};
